import z from 'zod'

import { MarketSummary } from '@fortem-monorepo/web-sdk'

export const addMetricSchema = z
  .object({
    metric_type: z.enum(['price', 'calculation']),
    calculation: z.literal('return'),
    period_type: z.enum(['event', 'frequency']),
    price_offset_days: z.number().nullish(),
    event_id: z.number().int().nonnegative().nullish(),
    return_frequency: z.string().nullable(),
  })
  .superRefine((data, ctx) => {
    if (data.metric_type === 'price') {
      if (data.price_offset_days == null || !Number.isInteger(data.price_offset_days) || data.price_offset_days < 0) {
        ctx.addIssue({
          code: 'custom',
          path: ['price_offset_days'],
          message: 'Enter a whole number of days, at least 0',
        })
      }
    } else if (data.period_type === 'event') {
      if (data.event_id == null) {
        ctx.addIssue({ code: 'custom', path: ['event_id'], message: 'Select an event' })
      }
    } else if (data.return_frequency == null || data.return_frequency.length === 0) {
      ctx.addIssue({ code: 'custom', path: ['return_frequency'], message: 'Select a return frequency' })
    }
  })

export type AddMetricFormValues = z.infer<typeof addMetricSchema>

export const addMetricDefaults: AddMetricFormValues = {
  metric_type: 'price',
  calculation: 'return',
  period_type: 'event',
  price_offset_days: null,
  event_id: null,
  return_frequency: null,
}

export const getAddMetricParams = (
  data: AddMetricFormValues,
  display_id: number,
): MarketSummary.AddMetricToDisplayParams => ({
  display_id,
  price_offset_days: data.metric_type === 'price' ? data.price_offset_days : null,
  event_id: data.metric_type === 'calculation' && data.period_type === 'event' ? data.event_id : null,
  return_frequency:
    data.metric_type === 'calculation' && data.period_type === 'frequency' ? data.return_frequency : null,
})
